/**
 * @param {Array} array Array of values to search in
 * @param {Number | String} value Value searched in array
 */
export function arrayIncludesString(array, value) {
    return array.includes(value) || array.includes(String(value))
}

/**
 * @param {Array} arrayOne Array of values
 * @param {Array} arrayTwo Array of values
 */
export function arraysIntersect(arrayOne, arrayTwo) {
    const filteredArray = arrayOne.filter(function (n) {
        return arrayTwo.indexOf(n) !== -1;
    });
    return filteredArray.length > 0
}

export function removeUnderscoreKeys(obj) {
    if (Array.isArray(obj)) {
        return obj.map(removeUnderscoreKeys);
    } else if (obj && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            if (!key.startsWith('_')) {
                acc[key] = removeUnderscoreKeys(obj[key]);
            }
            return acc;
        }, {});
    }
    return obj;
}

export function duplicateObject(obj) {
    if (Array.isArray(obj)) {
        return obj.map(duplicateObject);
    } else if (obj && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc, key) => {
            acc[key] = removeUnderscoreKeys(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}

/**
 * Returns the value when truthy, otherwise an en-dash placeholder.
 * @param {*} value Value to display
 * @returns {*} The value, or '–' when empty/falsy
 */
export function displayValue(value) {
    if (value) {
        return value
    }
    return '–'
}